import React, { useEffect, useState } from 'react';
import { Box, VStack, Text, Select, Input, Button, useToast } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import { listOwnerComics, addChapterToComic, type ComicDoc } from '../services/contentService';
import { uploadFileDirect } from '../services/uploadService';

const AddChapter: React.FC = () => {
  const { user } = useAuth();
  const toast = useToast();
  const [comicId, setComicId] = useState('');
  const [title, setTitle] = useState('');
  const [chapterNumber, setChapterNumber] = useState<number>(1);
  const [file, setFile] = useState<File | null>(null);
  const [options, setOptions] = useState<{ id: string; title: string }[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user) return;
    listOwnerComics(user.uid).then((list: ComicDoc[]) => setOptions(list.map((s: ComicDoc) => ({ id: s.id!, title: s.title }))));
  }, [user]);

  const handleSave = async () => {
    if (!user) { toast({ title: 'Please sign in', status: 'warning' }); return; }
    if (!comicId || !file || !title) { toast({ title: 'Fill all fields', status: 'warning' }); return; }
    setSaving(true);
    try {
      const assetUrl = await uploadFileDirect(`users/${user.uid}/chapters/${comicId}`, file);
      await addChapterToComic(comicId, { 
        title, 
        chapterNumber, 
        description: '', 
        fileUrl: assetUrl, 
        thumbnail: '', 
        pages: 0 
      });
      toast({ title: 'Chapter added', status: 'success' });
      setTitle(''); setChapterNumber(1); setFile(null); setComicId('');
    } catch (e: any) {
      toast({ title: 'Failed to add chapter', description: e.message, status: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box maxW="600px" mx="auto" p={6}>
      <VStack align="stretch" gap={4}>
        <Text fontSize="2xl" fontWeight="bold">Add Chapter to Comic/Novel</Text>
        <Select placeholder="Select comic/novel" value={comicId} onChange={(e) => setComicId(e.target.value)}>
          {options.map(o => <option key={o.id} value={o.id}>{o.title}</option>)}
        </Select>
        <Input placeholder="Chapter title" value={title} onChange={(e) => setTitle(e.target.value)} />
        <Input type="number" placeholder="Chapter number" value={chapterNumber} onChange={(e) => setChapterNumber(parseInt(e.target.value || '1', 10))} />
        <Input type="file" accept="application/pdf,image/*" onChange={(e) => setFile(e.target.files?.[0] || null)} />
        <Button colorScheme="purple" onClick={handleSave} isLoading={saving}>Add Chapter</Button>
      </VStack>
    </Box>
  );
};

export default AddChapter;



